import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
var NewDocument = function () { return (_jsx(Navigate, { to: "/documents", replace: true, state: { openNewDocument: true } })); };
export default NewDocument;
